import React from 'react'

export default function AttendanceSettingsTipsCard() {
  const tips = [
    {
      icon: 'schedule',
      title: 'Automatic Attendance Sync',
      text: 'Setting Student Swipes to "Automatic" runs a daily reconciliation at 9:00 PM. Students with valid terminal swipes are marked Present, others as Absent. If no students in a course/branch swiped, it is treated as a Holiday.',
    },
    {
      icon: 'notification_important',
      title: 'Absentee Parent Alerts',
      text: 'Setting Absentee Alerts to "Automatic" will automatically dispatch SMS and WhatsApp notifications to configured parent contacts (Father / Mother) after 9:00 PM for all absent students.',
    },
    {
      icon: 'sync_alt',
      title: 'Real-Time Gate Swipes',
      text: 'Enabling In / Out Gate notifications sends immediate real-time arrival (first swipe) and departure (last swipe) alerts to parents.',
    },
    {
      icon: 'timer',
      title: 'Debounce Gap Window',
      text: 'The Minimum Gap setting instructs the machine reconciliation engine to ignore duplicate swipes made in quick succession within the specified minutes window.',
    },
  ]

  return (
    <div className="flex flex-col gap-5 rounded-3xl border border-outline-variant/25 bg-surface-container-lowest p-6 sm:p-8 shadow-xs">
      <div className="flex items-center gap-2.5 text-primary">
        <span className="material-symbols-outlined text-2xl">tips_and_updates</span>
        <h3 className="font-display text-base font-bold text-on-surface">
          Attendance Automation Tips
        </h3>
      </div>

      <div className="flex flex-col gap-4">
        {tips.map((tip, idx) => (
          <div
            key={idx}
            className="flex items-start gap-3 rounded-2xl border border-outline-variant/15 bg-surface-container-low/40 p-4 transition-colors hover:bg-surface-container-low"
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <span className="material-symbols-outlined text-base">{tip.icon}</span>
            </div>
            <div className="flex flex-col gap-0.5">
              <h4 className="text-xs font-bold text-on-surface">{tip.title}</h4>
              <p className="text-[11px] leading-relaxed text-on-surface-variant">{tip.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
